import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, Typography } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { showMessage } from '../../../store/actions/messages.actions';
import { placeWritePermission } from '../../../store/selectors/account.selector';
import store from '../../../store/store';
import { setTerritoriesRefresh, unarchiveTerritory } from '../../../store/actions/territories.actions';

const TerritoryUnArchiveDialog = ({ handleClose, ...props }) => {
  const dispatch = useDispatch();
  const { action0, actionId0, action1, actionId1 } = useParams();

  const editPermission = useSelector(placeWritePermission);

  const territories = useSelector((state) => state.territories.archive);
  const [territorySelected, setTerritorySelected] = useState({});
  const [archiveDialog, setArchiveDialog] = useState(false);

  // state effect
  useEffect(() => {
    let unmounted = false;
    const territoryFromList = actionId0 && (territories.find((item) => item.id === actionId0));
    if (action0 === 'restore') {
      setArchiveDialog(true);
    } else {
      setArchiveDialog(false);
    }
    if (action0 === 'restore' && actionId0) {
      setTerritorySelected({
        ...territoryFromList,
      });
    }
    return () => {
      unmounted = true;
    };
  }, [action0, action1, actionId0, actionId1, territories]);

  const onUnArchiveTerritory = async () => {
    try {
      await store.dispatch(unarchiveTerritory(actionId0));
      dispatch(showMessage({ open: true, text: 'Территория успешно восстановлена из архива', severity: 'success' }));
      handleClose(null, 'success');
      setTimeout(() => dispatch(setTerritoriesRefresh()), 500);
    } catch (error) {
      console.log(error);
      dispatch(showMessage({ open: true, text: `Не удалось восстановить из архива. ${error.message}`, severity: 'error' }));
    }
  };

  return (
    <>
      {/* archive dialog */}
      <Dialog {...props} open={archiveDialog} onClose={handleClose} disableRestoreFocus>
        <DialogTitle>
          <Box sx={{ fontSize: '22px' }}>
            Восстановить из архива?
          </Box>
        </DialogTitle>
        <DialogContent sx={{ paddingBottom: '8px' }}>
          <Typography
            color="textSecondary"
            variant="body1"
          >
            <span>Территория с названием </span>
            <strong>{territorySelected.name}</strong>
            <span> будет перемещена в основной жилфонд</span>
          </Typography>
          <Grid
            container
            justifyContent="space-between"
            spacing={2}
            sx={{
              pb: 2,
              pt: 4,
            }}
          >
            <Grid
              item
            >
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                onClick={handleClose}
              >
                Отменить
              </Button>
            </Grid>
            <Grid
              item
            >
              {editPermission && (
                <Button
                  variant="contained"
                  color="purple"
                  fullWidth
                  onClick={onUnArchiveTerritory}
                >
                  Восстановить
                </Button>
              )}
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

TerritoryUnArchiveDialog.propTypes = {
  handleClose: PropTypes.func,
};

TerritoryUnArchiveDialog.defaultProps = {
  handleClose: null,
};

export default TerritoryUnArchiveDialog;
